import { Button, Callout, CodeCopy, Col, H4, PortableText, Row, Small, SpacerWrapper } from '@ahmdigital/ui';
import { compact, isEmpty, isUndefined, map, startsWith } from 'lodash/fp';
import Icon from '@ahmdigital/icons-web';

import { GetPerkQuery } from '../../../../../types/__codegen__/sanity/graphql';
import constants from '../../../../../ahm-constants';
import getMemberNumber from '../../../../../utils/get-oms-member-number';
import styles from './styles.module.sass';

type VoucherCalloutProps = {
  perk: GetPerkQuery['allMemberPerk'][number];
  queryMagicLinkCode?: string;
  showDisclaimerText?: boolean;
};

const VoucherCallout = ({ perk, queryMagicLinkCode = '', showDisclaimerText = false }: VoucherCalloutProps) => {
  const vouchers = perk?.discountCodes;
  const hasVouchers = !isEmpty(vouchers);
  const isMatchingMagicLink = !isEmpty(queryMagicLinkCode) && queryMagicLinkCode === perk?.magicLinkCode?.current;
  const isExistingMember = !isUndefined(getMemberNumber());
  const showVouchers = isMatchingMagicLink || isExistingMember;
  const cta = perk?.urlObject;
  // @ts-expect-error - Automatic, Please fix when editing this file
  const linkIcon = !startsWith('/', cta?.url) ? { name: 'external-link-light', position: 'right' } : null;

  const disclaimer = perk?.disclaimer;
  const disclaimerSymbol = disclaimer?.symbol;
  const disclaimerContent =
    showDisclaimerText && disclaimer?.contentRaw ? (
      <SpacerWrapper variant="marginTopSpacer6">
        <Small className={styles.flexRow}>
          {disclaimerSymbol}
          <PortableText source={disclaimer?.contentRaw} />
        </Small>
      </SpacerWrapper>
    ) : null;

  if (hasVouchers) {
    // @ts-expect-error - Automatic, Please fix when editing this file
    const hasMultipleVouchers = vouchers.length > 1;
    const codeColWidth = 6;
    return (
      <>
        <H4 looksLike="h6">Promo code{hasMultipleVouchers ? 's' : ''}</H4>
        {showVouchers ? (
          <Row variant="marginTopSpacer11">
            {map(
              ({ code, descriptionRaw }) => (
                <Col
                  variant="marginBottomSpacer10"
                  key={code?.current}
                  df={codeColWidth}
                  md={codeColWidth}
                  sm={8}
                  xs={12}
                >
                  <CodeCopy
                    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'Maybe<string> | undefined' is not assignable to type 'string'.
                    codeValue={code?.current}
                    label={descriptionRaw?.[0]?.children[0]?.text}
                    title="Copy promo code"
                  />
                </Col>
              ),
              compact(vouchers),
            )}

            <Col df={12} sm={12} xs={12}>
              {cta ? (
                <>
                  {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: any[]; variant: string; icon: { name: string; position: string; } | null; to: Maybe<string> | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<Pick<ButtonProps, keyof ButtonProps> & Pick<InferProps<{ variant: Requireable<NonNullable<string | object | null | undefined>>; analytics: Requireable<...>; }>, "analytics"> & Pick<...>, "icon" | "analytics"> & Partial<...> & Partial<...>'. */}
                  <Button variant="purple" icon={linkIcon} to={cta.url}>
                    {cta.name}
                    {disclaimerSymbol}
                  </Button>
                  {disclaimerContent}
                </>
              ) : null}
            </Col>
          </Row>
        ) : (
          <Row>
            <Col df={6} md={7} sm={12}>
              <Callout variant={styles.promoCode}>
                <div className={styles.iconContainer}>
                  <Icon name="lock" size="large" data-testid="lock" className={styles.icon} />
                  Log in for code
                </div>
              </Callout>
            </Col>
            <Col df={6} md={5} sm={12}>
              <Button variant={['wide', 'purple', styles.loginButton]} to={constants.URLS.MEMBERS.LOGIN}>
                Log in
              </Button>
            </Col>
          </Row>
        )}
      </>
    );
  }

  return cta?.url ? (
    <>
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: any[]; icon: { name: string; position: string; } | null; to: string; variant: string; }' is not assignable to type 'IntrinsicAttributes & Pick<Pick<ButtonProps, keyof ButtonProps> & Pick<InferProps<{ variant: Requireable<NonNullable<string | object | null | undefined>>; analytics: Requireable<...>; }>, "analytics"> & Pick<...>, "icon" | "analytics"> & Partial<...> & Partial<...>'. */}
      <Button icon={linkIcon} to={cta.url} variant="purple">
        {cta.name}
        {disclaimerSymbol}
      </Button>
      {disclaimerContent}
    </>
  ) : null;
};

export default VoucherCallout;
